import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useLayerSidebarPanel } from './LayerSidebarPanel';
import { useUscgMapContext } from './UscgMapContext';
import type { InternalLayer } from 'hooks/internalLayer/types';

// disabled if 'DRAFT' or 'PENDING' internal_layer_version already exists
export function EditInternalLayerVersionButton({
  internalLayer,
}: {
  internalLayer: InternalLayer;
}) {
  const { setActivePanel } = useLayerSidebarPanel();
  const { setSidebarSelectedInternalLayer } = useUscgMapContext();

  return (
    <StylishNewButton
      title={'Edit layer version'}
      className={'button--primary pe-auto'}
      onClick={() => {
        setSidebarSelectedInternalLayer(internalLayer);
        setActivePanel('edit_layer_version');
      }}
    >
      <SharedIcon iconName="add" size="sm" />
      Edit Version
    </StylishNewButton>
  );
}
